// extracted by mini-css-extract-plugin
export var quillEditor = "_mt-1";
export var variable = "_mt-0";